module.exports = __webpack_public_path__ + "media/img/frontend_application/reward_img-9dffd4bfea648952a1c0c2fddd83d002.jpg";